module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    staticStyle: {
      "background-color": "#eff2f5"
    }
  }, [_c('section', [_c('hospital-select', {
    on: {
      "selected": _vm.selectHospital
    }
  }), _vm._v(" "), _c('voucher-select', {
    attrs: {
      "list": _vm.voucherList
    },
    on: {
      "selected": _vm.selectVoucher
    }
  })], 1), _vm._v(" "), _c('scroll', {
    staticClass: "from-query",
    staticStyle: {
      "padding-bottom": "2rem"
    },
    on: {
      "refresh": _vm.refresh
    }
  }, [_vm._l((_vm.unpayList), function(unpay) {
    return _c('section', {
      staticClass: "thick",
      on: {
        "click": function($event) {
          return _vm.goDetail(unpay)
        }
      }
    }, [_c('div', {
      staticClass: "panel"
    }, [_c('span', [_vm._v(_vm._s(unpay.deptName))])]), _vm._v(" "), _c('div', {
      staticClass: "row arr-row table-row"
    }, [_c('div', {
      staticClass: "col"
    }, [_c('span', {
      staticClass: "f-minor"
    }, [_vm._v("总金额")]), _vm._v("  "), _c('span', {
      staticClass: "f-strongest"
    }, [_vm._v(_vm._s(_vm._f("formatFee")(unpay.totalFee)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "f-minor"
    }, [_vm._v("开单时间")]), _vm._v("  "), _c('span', {
      staticClass: "f-minor"
    }, [_vm._v(_vm._s(_vm._f("formatpayDate")(unpay.visitTime)))]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "col"
    })])])
  }), _vm._v(" "), _c('no-record', {
    attrs: {
      "condition": _vm.unpayList,
      "tips": _vm.nodataTitle
    }
  })], 2), _vm._v(" "), _c('footer', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unpayList.length > 0),
      expression: "unpayList.length > 0"
    }],
    staticClass: "btn-complete",
    staticStyle: {
      "border-radius": "0"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirm(_vm.unpayList)
      }
    }
  }, [_vm._v("缴费")])]), _vm._v(" "), _c('payConfirm', {
    model: {
      value: (_vm.showPayConfirm),
      callback: function($$v) {
        _vm.showPayConfirm = $$v
      },
      expression: "showPayConfirm"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-429788f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/clinic/ClinicUnpayList.vue
// module id = 820
// module chunks = 0